/**
 * Route guard for /admin/* routes.
 *
 * Phase: 4
 *
 * Checks `isAuthenticated()` (presence of a token in localStorage). If absent,
 * redirects to /admin/login while preserving the intended destination in
 * location.state.from so Login can return there after success.
 */

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "../lib/auth";

export function ProtectedRoute() {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
